import React, { ReactElement } from 'react';
import ReactLoading from 'react-loading';

const Loader = (): ReactElement => (
	<div className='loader'>
		<ReactLoading color='#FFF' type='spinningBubbles' height={'10%'} width={'10%'} className='margin-auto' />
	</div>
);

export default Loader;
